"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaGlobalApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaGlobalApiClient extends BaseApiClient_1.BaseApiClient {
    async retrieveCompanyInfo() {
        const path = `/v1/companyinfo`;
        return await this.request("get", path, undefined, undefined);
    }
    async listIncotermShippingRules() {
        const path = `/v1/incotermshiprules`;
        return await this.request("get", path, undefined, undefined);
    }
    async listLabels(queryParams) {
        const path = `/v1/labels`;
        return await this.request("get", path, queryParams, undefined);
    }
    async createLabels(labels) {
        const path = `/v1/labels`;
        return await this.request("put", path, undefined, labels);
    }
    async deleteLabels(labelId) {
        const path = `/v1/labels/${labelId || ""}`;
        return await this.request("delete", path, undefined, undefined);
    }
    async listOrderPaymentTypes() {
        const path = `/v1/paymenttypes`;
        return await this.request("get", path, undefined, undefined);
    }
    async listSalesChannels(queryParams) {
        const path = `/v1/saleschannels`;
        return await this.request("get", path, queryParams, undefined);
    }
    async createANewApiSalesChannel(queryParams) {
        const path = `/v1/saleschannels`;
        return await this.request("put", path, queryParams, undefined);
    }
    async retrieveWarehouseByIdentifier(id) {
        const path = `/v1/warehouse/${id || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async listWarehouses() {
        const path = `/v1/warehouses`;
        return await this.request("get", path, undefined, undefined);
    }
}
exports.SkubanaGlobalApiClient = SkubanaGlobalApiClient;
